// Blank barge cover form for manual pellet entry (no pre-populated pellet_id).
// For the pre-populated form (from pellet "Settings" button), see cover.tsx.
import { createFileRoute, useSearch } from '@tanstack/react-router';
import { BargeCoverForm, navigateToError } from '@amber-ui/core';

function BargeCoversRoute() {
  const { barge } = useSearch({ strict: false }) as { barge?: string };
  const barge_id = barge || null;

  if (!barge_id) return null;

  return (
    <BargeCoverForm
      barge_id={barge_id}
      onError={() => {
        navigateToError();
      }}
    />
  );
}

export const Route = createFileRoute('/_auth/_barge/barge/covers')({
  component: BargeCoversRoute,
});
